export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Adjust for timezone offset to prevent off-by-one day errors
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() + userTimezoneOffset);
  return new Intl.DateTimeFormat('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }).format(adjustedDate);
};
